/** 組裝送往後端 API 的 $fetch options（baseURL + headers）。 */
export function buildApiOptions(args: {
  apiBase: string
  fingerprint: string
  token: string | null
}): { baseURL: string; headers: Record<string, string> } {
  const headers: Record<string, string> = { Fingerprint: args.fingerprint }
  if (args.token) {
    headers.Authorization = `Bearer ${args.token}`
  }
  return { baseURL: `${args.apiBase}/api`, headers }
}

/**
 * 是否該把這個回應當成「token 過期」處理（清 token + 導回登入）。
 * 只有「已帶 token 的請求」收到 401 才算；登入失敗的 401（當下無 token）不算。
 */
export function shouldHandleAuthExpiry(status: number, token: string | null): boolean {
  return status === 401 && !!token
}
